import {
    AspectRatio,
    Box,
    BoxProps,
    Button,
    Flex,
    Heading,
    Text,
    Wrap,
    WrapItem
} from '@chakra-ui/react';
import { EventType } from '@components/Event';
import { useAnalytics } from '@lib/analytics';
import { intl_html_values } from '@lib/localization/intl';
import { ExhibitorType } from '@lib/types';
import { AnimatePresence, motion } from 'framer-motion';
import NextImage from 'next/image';
import NextLink from 'next/link';
import { FunctionComponent, useEffect, useRef, useState } from 'react';
import { FaChevronRight } from 'react-icons/fa';
import { FormattedMessage } from 'react-intl';
const SponsorSlideshow: FunctionComponent<
    {
        sponsors: ExhibitorType[];
        event: EventType;
        seconds?: number;
    } & BoxProps
> = ({ sponsors, event, seconds = 5, ...props }) => {
    const [activeIndex, setActiveIndex] = useState(Math.floor(Math.random() * sponsors.length));
    const sponsor = sponsors[activeIndex];
    const { analytics } = useAnalytics();
    const ref = useRef<HTMLDivElement>(null);
    useEffect(() => {
        let nextIndex = activeIndex - 1;
        const slideShowInterval = setInterval(() => {
            nextIndex++;
            nextIndex = nextIndex >= sponsors.length ? 0 : nextIndex;
            console.log(nextIndex);
            setActiveIndex(nextIndex);
        }, 1000 * seconds);
        return () => clearInterval(slideShowInterval);
    }, [sponsors]);

    if (!sponsor) {
        return null;
    }

    return (
        <Box ref={ref} {...props}>
            <AnimatePresence exitBeforeEnter>
                <motion.div
                    key={sponsor.id}
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}>
                    <Wrap spacing="4" align="center" justify="space-between">
                        <WrapItem flexGrow={1} maxW="160px">
                            {sponsor.logo && sponsor.logo.src ? (
                                <AspectRatio width="160px" ratio={16 / 9}>
                                    <NextImage
                                        sizes="400px"
                                        src={sponsor.logo.src}
                                        alt={sponsor.name}
                                        layout="fill"
                                        objectFit="contain"
                                        objectPosition="left center"
                                    />
                                </AspectRatio>
                            ) : null}
                        </WrapItem>
                        <WrapItem flexGrow={1} w="280px">
                            <Flex flexDir="column" p="2" minHeight="120px" justifyContent="center">
                                <Heading as="h3" size="md">
                                    {sponsor.name}
                                </Heading>
                                {sponsor.description ? (
                                    <Text fontSize="sm" mb="4">
                                        {sponsor.description}
                                    </Text>
                                ) : null}
                            </Flex>
                        </WrapItem>
                    </Wrap>
                    <Box
                        w="full"
                        textAlign="right"
                        pos="absolute"
                        right="0"
                        bottom="0"
                        bg="rgba(255,255,255,0.9)"
                        zIndex={1}>
                        <NextLink
                            passHref
                            href={
                                sponsor.external_detail_link
                                    ? sponsor.external_detail_link
                                    : `/events/${event.id}/exhibition/detail?sid=${sponsor.id}`
                            }>
                            <Button
                                variant="solid"
                                borderRightRadius="0"
                                borderBottomLeftRadius="0"
                                colorScheme="brand"
                                size="xs"
                                as="a"
                                textAlign="right"
                                rightIcon={<FaChevronRight />}
                                target={sponsor.external_detail_link ? '_blank' : '_self'}
                                onClick={() => {
                                    analytics.send('exhibition_ad_click', {
                                        _action: 'click',
                                        _category: 'exhibition_ad',
                                        _label: sponsor.name,
                                        cpd1: 'sponsoring_id',
                                        cpv1: sponsor.id,
                                        event_id: event.id
                                    });
                                }}>
                                <FormattedMessage
                                    id="player.exhibition_ads.visit_exhibitor"
                                    defaultMessage="Ausstellungsstand besuchen"
                                    values={{
                                        ...intl_html_values
                                    }}
                                />
                            </Button>
                        </NextLink>
                    </Box>
                </motion.div>
            </AnimatePresence>
        </Box>
    );
};

export default SponsorSlideshow;
